export default "__VITE_ASSET__f9710da4__"